// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__lMET5","range":"MonthRangeSwitch_range__28XLs","disabled":"MonthRangeSwitch_disabled__29qdw"};